import { t } from '@lingui/macro';
import { getAbnormalMessages } from 'api/api';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DV from 'variables/DV';
import { LIST_DOMAIN } from 'variables/staticValue';
import { useApi } from '../../../hook/utils';
import { chartsDateRangeSelector } from '../utils';
import InsightStatisticCard from './InsightStatisticCard';

const MOCK_ABNORMAL_MESSAGES = {
  results: [
    {
      id: 1,
      seller_name: 'Ton Nguyen',
      content: 'Cái message này hơi kỳ kỳ.',
      inbox_id: 'mock-inbox-1',
      message_id: 'mock-message-1',
    },
    {
      id: 2,
      seller_name: 'Ton Nguyen',
      content: 'Cái này tào lao anh ơi',
      inbox_id: 'mock-inbox-2',
      message_id: 'mock-message-2',
    },
    {
      id: 3,
      seller_name: 'Truong Hua',
      content: 'Xyz abc',
      inbox_id: 'mock-inbox-3',
      message_id: 'mock-message-3',
    },
    {
      id: 4,
      seller_name: 'Le Van A',
      content:
        'Tin nhắn dài để test clamp hai dòng xem có bị cắt đúng không khi nội dung quá dài vượt quá chiều cao của một dòng text.',
      inbox_id: 'mock-inbox-4',
      message_id: 'mock-message-4',
    },
  ],
};

const USE_MOCK_DATA = process.env.NODE_ENV === 'development';

const getCenterUrl = (item = {}) => {
  const base = `${LIST_DOMAIN[DV.partner].centerURL}?device_id=${DV.staffDeviceId}&token=${DV.token}`;
  const params = [];
  if (item.inbox_id) params.push(`inbox_id=${encodeURIComponent(item.inbox_id)}`);
  if (item.message_id) params.push(`message_id=${encodeURIComponent(item.message_id)}`);
  return params.length ? `${base}&${params.join('&')}` : base;
};

const AbnormalMessages = (props) => {
  const { getApi = getAbnormalMessages, title = t`Tin nhắn bất thường`, canDelete, code } = props;
  const { since, until } = useSelector(chartsDateRangeSelector());
  const { loading, data, doFetch } = useApi();
  const [error, setError] = useState({});

  useEffect(() => {
    if (USE_MOCK_DATA) return;
    (async () => {
      if (!since || !until) return;
      setError({});
      const { error, ...rest } = await doFetch(getApi({ since, until }));
      if (error) setError({ error, ...rest });
    })();
  }, [since, until]);

  const results = USE_MOCK_DATA ? MOCK_ABNORMAL_MESSAGES.results : data?.results || [];

  const handleOpenMessage = (item) => {
    window.open(getCenterUrl(item), '_blank');
  };

  const renderList = () => {
    return results.map((item, index) => (
      <button
        key={item.id}
        type="button"
        onClick={() => handleOpenMessage(item)}
        style={{
          display: 'block',
          width: '100%',
          border: 'none',
          borderTop: index > 0 ? '1px solid #AAAAAA' : 'none',
          padding: '8px 0',
          background: 'none',
          textAlign: 'left',
          cursor: 'pointer',
        }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontWeight: 600, fontSize: 12, fontFamily: 'Open Sans' }}>
            {item.seller_name}
          </span>
          <i className="fal fa-external-link" style={{ fontSize: 16 }} />
        </div>
        <div
          style={{
            fontWeight: 400,
            fontSize: 12,
            lineHeight: '16px',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}>
          {item.content}
        </div>
      </button>
    ));
  };

  return (
    <InsightStatisticCard
      title={title}
      canDelete={canDelete}
      code={code}
      loading={!USE_MOCK_DATA && loading}
      error={!USE_MOCK_DATA ? error : {}}
      showEmpty={isEmpty(results)}>
      {renderList()}
    </InsightStatisticCard>
  );
};

AbnormalMessages.propTypes = {
  getApi: PropTypes.func,
  title: PropTypes.string,
  canDelete: PropTypes.bool,
  code: PropTypes.string,
};

export default memo(AbnormalMessages);
